import { Component } from "react"
import axios from "axios"
import { connect } from "react-redux"
import { fetchUser } from '../reducer/userActions';



class AddDeposit extends Component {
    state = {
        loading: false,
        error: "",
        method: "bitcoin",
        amount: 0,

    }
    handleInput = (event) => {
        const { name, value } = event.target
        this.setState({
            [name]: value
        })
    }

    handleSubmit = async (e) => {
        e.preventDefault()
        this.setState({ loading: true });

        const accessToken = localStorage.getItem("teslaUserAccessToken"); // ✅ fixed key name

        const dataToSend = {
            method: this.state.method,
            amount: this.state.amount,
            uniqueID: this.props.uniqueID
        }

        try {
            const response = await axios.post(`https://teslasafebroker.com/api/deposit/crypto`, dataToSend, {
                headers: { Authorization: `Bearer ${accessToken}` }
            });

            if (response.data && response.data.user) {
                this.setState({
                    loading: false,
                    method: "bitcoin",
                    amount: 0
                });
                this.props.fetchUser();
                this.displayDepositForm()
            } else {
                // Fallback if user is not returned (avoid stuck loading)
                this.setState({ loading: false,
                    method: "bitcoin",
                    amount: 0
                 });
            }

            console.log("User information:", response.data.user);

        } catch (error) {
            // Always clear loading state
            this.setState({ loading: false });

            if (error.response.status === 401) {
                // ✅ Make sure to check error.response exists first
                localStorage.removeItem("teslaUserAccessToken");
                localStorage.removeItem("teslaUserInfo");
                // Optional: redirect or show login expired message
                window.location.href = "/login";
                console.log(error)
            } else {
                console.error("Error fetching user data:", error);
                this.setState({ network: true }); // optional network error flag
            }
        }
    };


    displayDepositForm = () => {
        this.props.displayDepositForm(false)
    }



    render() {
        const { method, amount, error, loading } = this.state
        console.log("the deposit", this.state)

        return (
            <div className="add_form_background">
                <div className="add_form_container">
                    <div className="add_form_cover">
                        <h2>Create Deposit</h2>
                        <p>{error}</p>
                        <form onSubmit={this.handleSubmit}>
                            <label>Methode</label>
                            <select name="method" id="method" value={method} onChange={this.handleInput} required>
                                <option value="bitcoin">Bitcoin (BTC)</option>
                                <option value="ethereum">Ethereum (ETH)</option>
                                <option value="bnb">BNB</option>
                                <option value="tether TRC">Tether (USDT TRC20)</option>
                            </select><br /><br />

                            <label>Amount</label>
                            <input type="number" name="amount" id="amount" value={amount} onChange={this.handleInput} required/><br /><br />
                            <div className="button">
                                <button disabled={loading}>Submit</button>
                                <button type="button" onClick={this.displayDepositForm}>Cancle</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        )
    }
}


const mapStateToProps = (state) => ({
    user: state.user,
});





export default connect(mapStateToProps, { fetchUser })(AddDeposit) 